import { Link, useParams } from "react-router-dom";
import { Card } from "../components/ui/card.jsx";
import { Button } from "../components/ui/button.jsx";

const content = {
  regulations: {
    title: "Regulations",
    bullets: [
      "Licensing, hunter education, permits",
      "Legal methods, caliber/shot rules",
      "Tagging, reporting, bag limits",
      "Private vs public land access",
    ],
  },
  seasons: {
    title: "Seasons",
    bullets: [
      "Species calendars by zone",
      "Method: archery / muzzleloader / firearm",
      "Unit maps & boundaries",
      "Always verify official dates",
    ],
  },
  species: {
    title: "Species Anatomy & Habitat",
    bullets: [
      "Vital zones by game & birds",
      "Behavior & seasonal patterns",
      "Best time to hunt / when to avoid",
      "Habitat & range",
    ],
  },
  gear: {
    title: "Gear & Prep",
    bullets: [
      "Loadouts by species & style",
      "Treestands vs blinds",
      "Safety essentials",
      "Check state-legal gear rules",
    ],
  },
  resources: {
    title: "Local Resources",
    bullets: [
      "Licensing portals",
      "WMAs & access programs",
      "Agency contacts",
      "Hunter ed & safety",
    ],
  },
};

export default function TopicInfo() {
  const { key } = useParams();
  const data = content[key] || { title: "Topic", bullets: [] };
  return (
    <div className="container mx-auto px-6 py-10" data-testid="topic-info-page">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl md:text-4xl font-bold font-serif text-white" data-testid="topic-info-title">{data.title}</h1>
        <Link to="/" data-testid="topic-info-back">
          <Button variant="outline" className="rounded-full">Back</Button>
        </Link>
      </div>
      <Card className="p-6 mt-6 bg-white/5 border-white/10 text-white" data-testid="topic-info-card">
        <ul className="list-disc pl-6 space-y-2">
          {data.bullets.map((b, i) => (
            <li key={i}>{b}</li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
